const dateParse = (dateString) =>
  new Date(dateString).toLocaleString(undefined, {
    timeZoneName: 'short',
  });

export default dateParse;
